/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RootInputs */



/**
* | output |
* | --- |
* | "Root" |
*
* @param {RootInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const root = /** @type {((inputs?: RootInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RootInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Racine")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wurzel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Radice")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Корень")
	if (locale === "es") return /** @type {LocalizedString} */ ("Raíz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("根")
	if (locale === "ja") return /** @type {LocalizedString} */ ("根")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जड़")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Raiz")
	return /** @type {LocalizedString} */ ("Root")
});